<template>
    <skeleton-loader v-if="loading" type="athlete" />
    <v-card v-else-if="student" v-ripple flat
        @click="pushRoute({ name: 'coach.students.profile', params: { uid: studentId } })" class="athlete-card">
        <div class="athlete-logo" :style="hasAvatar ? { backgroundImage: `url('${studentImg}')` } : null">
            <v-icon v-if="!hasAvatar" size="22" color="#0C0E12">mdi-account</v-icon>
        </div>
        <div class="athlete-info">
            <div class="athlete-name text-truncate">{{ student.name }}</div>
        </div>
    </v-card>
</template>

<script>

import { db } from '@/utils/Firebase'
import SkeletonLoader from "@/components/common/SkeletonLoader";

export default {
    components: { SkeletonLoader },
    props: {
        studentId: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            student: null,
            loading: false,
        }
    },
    async mounted() {
        const vm = this
        await vm.loadStudent()
    },
    computed: {
        studentImg(vm = this) {
            return vm.student?.avatar || vm.imgPlaceholder
        },
        hasAvatar(vm = this) {
            return !!vm.student?.avatar
        },
    },
    methods: {
        async loadStudent() {
            let vm = this
            if (!vm.studentId) return
            await vm.withLoading(async () => {
                let studentRef = await db.collection('users').doc(vm.studentId).get()
                vm.student = studentRef.data()
            })
        }
    },
    watch: {
        studentId() {
            this.loadStudent()
        }
    }
}
</script>

<style scoped>
.athlete-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--v-surface-base) !important;
    border: 1px solid var(--v-outline-base);
    border-radius: 12px !important;
    padding: 10px 12px;
}

.athlete-logo {
    width: 40px;
    height: 40px;
    border-radius: 9px;
    flex-shrink: 0;
    background: linear-gradient(135deg, #CCFF33, #339999);
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.athlete-info {
    flex: 1;
    min-width: 0;
}

.athlete-name {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}
</style>
